import SimpleBadge from "./SimpleBadge.vue";

export { SimpleBadge };
export * from "./simpleBadge.types";

export default SimpleBadge;
